// eslint-disable-next-line
export default (value?: string): string =>
  value?.replace(/(<([^>]+)>)/gi, '') || '';
